const Director = 'Director'
const Manager = 'Manager'
const Analyst = 'Analyst'
const Financial = "Financial"
const SalesExecutive = 'SalesExecutive'
const CreditAnalyst = 'CreditAnalyst'
const Logistics = 'Logistics'
const Seller = 'Seller'

const employee_comission_routes = [
  {
    path: '/client_bonus',
    name: 'ClientBonus',
    meta: { 
      auth: true,
      roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
    },
    component: () => import('@/_backoffice/_financial/components/client_bonus/IndexClientBonus.vue'),
    children:[
      {
        path: 'payments',
        name: 'BonusPayments',
        meta: { 
          auth: true,
          roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
        },
        component: () => import('@/_backoffice/_financial/components/client_bonus/BonusPayments.vue'),
      },  
      {
        path: 'available',
        name: 'AvailableBonus',
        meta: { 
          auth: true,
          roles: [Director, SalesExecutive, Manager, Analyst, Financial, Logistics, Seller, CreditAnalyst],
        },
        component: () => import('@/_backoffice/_financial/components/client_bonus/AvailableBonus.vue'),
      },  
    ]
  },
  {
    path: '/client_bonus/payments/create',
    name: 'NewBonusPayment',
    meta: {
      auth: true,
      roles: ['Director', 'SalesExecutive', 'Manager', 'Analyst', 'Financial', 'Logistics', 'Seller', 'CreditAnalyst'],
    },
    component: () => import('@/_backoffice/_financial/components/order_payment/NewBonusPayment.vue'),
  },
]

export default employee_comission_routes
